import { render, staticRenderFns } from "./privateTransformerSubstationItem.vue?vue&type=template&id=3164e125&scoped=true"
import script from "./privateTransformerSubstationItem.vue?vue&type=script&lang=js"
export * from "./privateTransformerSubstationItem.vue?vue&type=script&lang=js"
import style0 from "./privateTransformerSubstationItem.vue?vue&type=style&index=0&id=3164e125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3164e125",
  null
  
)

export default component.exports